import type { AgendaDay, AgendaSection } from "../../types";

export const jlrAgendaSections: AgendaSection[] = [
  { number: "01", title: "Introductions", duration: "15 min" },
  { number: "02", title: "Demo", duration: "45 min" },
  { number: "03", title: "Platform", duration: "50 min" },
  { number: "04", title: "Discussion", duration: "30 min" },
];

export const jlrAgenda: AgendaDay[] = [
  {
    date: "Wednesday, April 8",
    label: "Day 1",
    sessions: [
      {
        time: "10:00 AM",
        title: "Arrive On-Site",
        audience: "On-site",
        description: "Setup and introductions with the JLR team",
      },
      {
        time: "1:00 – 3:30 PM (2.5h)",
        title: "Main Session",
        audience: "On-site attendees",
        description:
          "Full deck: Introductions → Demo → Platform → Discussion",
      },
    ],
  },
  {
    date: "Thursday, April 9",
    label: "Day 2",
    sessions: [
      {
        time: "7:30 AM",
        title: "Arrive On-Site",
        audience: "On-site",
        description: "Setup for remote session",
      },
      {
        time: "8:00 – 11:30 AM (3.5h)",
        title: "Remote Session",
        audience: "Remote (India + UK teams)",
        description:
          "Full deck: Introductions → Demo → Platform → Discussion",
      },
    ],
  },
];
